// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"87169905-168":"cce84dcff785b4cfc2f1","87169905-452":"85fd51ebc34c1e822a2d","87169905-379":"5f604cdedb7036397e26","87169905-83":"289e9e3063c52bc53e23"}[chunkId] + ".js";
};